import { html, LitElement } from "lit";
import { customElement, property } from 'lit/decorators.js';
import style from './usos-module-link-tile.scss';

/**
 * Tile for module navigation.
 *
 * @slot title - Element title
 * @slot text - Element description
 * @cssproperty [--module-link-tile-text-content-line-height=1] - Line height for text in description
 */
@customElement('usos-module-link-tile')
export class UsosModuleLinkTile extends LitElement {
    static override styles = style;

    /** Target URL for this tile. */
    @property() href = "";

    /** Image to be used as tinted icon on the left side of tile. */
    @property({attribute: 'mask-image'}) maskImage = "";

    constructor() {
        super();
        const internals = this.attachInternals();
        internals.role = 'listitem';
    }

    // render

    override render() {
        return html`
        <a href=${this.href}>
            <div>
                <div id="icon" style="mask-image: url('${this.maskImage}'); -webkit-mask-image: url('${this.maskImage}');" aria-hidden="true"></div>
                <div id="content">
                    <div id="title"><slot name="title"></slot></div>
                    <div id="text"><slot name="text"></slot></div>
                </div>
            </div>
        </a>
        `;
    }
}

declare global {
    interface HTMLElementTagNameMap {
      "usos-module-link-tile": UsosModuleLinkTile,
    }
}
